import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { useContext } from 'react';
import { useHasSoftPull } from '~/contexts/FinanceAndTradeContext';
import {
  SoftPullLocations,
  useOpenSoftPullModal
} from '~/hooks/useToggleSoftPullModal';
import LockedIcon from '~/icons/LockedIcon';
import UnlockedIcon from '~/icons/UnlockedIcon';

const UnlockPayment = () => {
  const { trackEvent } = useContext(AnalyticsContext);
  const openSoftpullModal = useOpenSoftPullModal(SoftPullLocations.Unlock);
  const showButton = !useHasSoftPull();
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    e.stopPropagation();
    trackEvent('Clicked Unlock Payment');
    openSoftpullModal();
  };

  return showButton ? (
    <button
      aria-label="Unlock Payment"
      className="bg-white border border-grey-2 flex gap-1 group/cta h-[34px] hover:bg-grey-1 hover:border-grey-3 items-center justify-center leading-5 px-4 py-2 rounded-full self-end text-blue-6 text-sm w-[151px]"
      data-analytics-id={null}
      onClick={handleClick}
      type="button"
    >
      <div className="flex self-center">
        <LockedIcon className="group-hover/cta:hidden m-auto" />
        <UnlockedIcon className="group-hover/cta:block hidden m-auto" />
        <span className="capitalize pl-4">unlock payment</span>
      </div>
    </button>
  ) : null;
};

export default UnlockPayment;
